import request from '@/common/request';

export function fetchDepositList(params) {
	return request({
		url: '/deposit',
		method: 'get',
		params,
	});
}

export function fetchDeposit(deposit_seq) {
	return request.get(`/deposit/${deposit_seq || 0}`);
}

export function createDeposit(data) {
	return request({
		url: `/deposit`,
		method: 'post',
		data,
	});
}

export function cancelDeposit(deposit_seq) {
	return request({
		url: `/deposit/${deposit_seq}`,
		method: 'patch',
		data: {
			type: 'SET_CANCELED',
		},
	});
}

export function fetchInvoiceList(params) {
	return request({
		url: '/invoice',
		method: 'get',
		params,
	});
}

export function fetchInvoice(invoice_seq) {
	return request.get(`/deposit/${invoice_seq || 0}`);
}

export function createInvoice(data) {
	return request({
		url: `/invoice`,
		method: 'post',
		data,
	});
}
